export default __webpack_public_path__ + "static/media/fa-regular-400.c579c7d9.woff";